import { Card } from "../components/Card";
import { Notice } from "../components/Notice";
import { PageHeader } from "../components/PageHeader";

const customerChecks = [
  "Confirm the contractor's identity before work starts.",
  "Verify licenses and permits directly for regulated work.",
  "Get the job, price, and materials in writing before anyone starts.",
  "Secure pets, valuables, gates, and access codes.",
  "Do not pay large deposits without checking local rules and contractor credentials.",
];

const contractorChecks = [
  "Confirm the job at arrival and stop if the work differs from the brief.",
  "Decline work that requires a license, permit, or equipment you do not have.",
  "Bring proper protective equipment and refuse unsafe site conditions.",
  "Keep pricing and schedule control in writing.",
  "Do not accept pressure to expand the job without a new written brief.",
];

function CheckList({ title, items, quote }: { title: string; items: string[]; quote: string }) {
  return (
    <Card
      footer={<p className="text-[var(--text-meta)] font-semibold text-text-muted">{quote}</p>}
      variant="surface"
    >
      <h2 className="text-xl font-semibold text-text">{title}</h2>
      <ol className="mt-4 space-y-3 text-sm leading-6 text-text-muted">
        {items.map((item, index) => (
          <li key={item} className="grid grid-cols-[2.25rem_1fr] gap-3">
            <span className="flex h-7 w-7 items-center justify-center rounded-pill border border-border font-sans text-lg font-bold leading-none text-accent-700">
              {String(index + 1).padStart(2, "0")}
            </span>
            <span>{item}</span>
          </li>
        ))}
      </ol>
    </Card>
  );
}

export function SafetyPage() {
  return (
    <div className="space-y-7">
      <PageHeader
        className="hero-aurora rounded-[28px] border border-border p-6 shadow-[var(--shadow-key-2)]"
        compact
        eyebrow="Stay safe"
        title="Hire smart, work safe."
      >
        ClearScope is a free tool, not a contractor screening service. Use this checklist before
        money or work changes hands.
      </PageHeader>

      <Notice title="We do not vet contractors" tone="warning">
        Anyone can list themselves on ClearScope. Always verify licenses, insurance, and references
        directly before hiring.
      </Notice>

      <div className="grid gap-5">
        <section className="grid gap-5 lg:grid-cols-2">
          <CheckList
            items={customerChecks}
            quote="A clear brief helps. It does not replace judgment."
            title="Before you hire"
          />
          <CheckList
            items={contractorChecks}
            quote="Clear details protect both sides before work starts."
            title="Before you take the job"
          />
        </section>
        <Card accentEdge="left" tone="warning" variant="surface">
          <h2 className="text-xl font-semibold text-text">High-risk work</h2>
          <p className="mt-3 text-sm leading-6 text-text-muted">
            Electrical, plumbing, structural, gas, roofing, asbestos, and similar work is regulated
            in many jurisdictions. Hire a licensed contractor and require permits where required.
            License numbers may be real, expired, fabricated, or assigned to someone else. Always
            verify through the relevant state or local board before work begins.
          </p>
        </Card>
      </div>
    </div>
  );
}
